import { render } from "./ShadowButton.vue?vue&type=template&id=f33dd5fc"
import script from "./ShadowButton.vue?vue&type=script&lang=js"
export * from "./ShadowButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__